// extracted by mini-css-extract-plugin
var _1 = "calculatorWrapper__Hbj_o";
var _2 = "textRow__xu9tU";
var _3 = "title__IMXV0";
var _4 = "totalBlock__FucuN";
export { _1 as "calculatorWrapper", _2 as "textRow", _3 as "title", _4 as "totalBlock" }
export default { "calculatorWrapper": _1, "textRow": _2, "title": _3, "totalBlock": _4 }
